import { Box, Link, Typography } from '@mui/material';
import WidgetBot from '@widgetbot/react-embed';
import { sessionSelector } from 'app/store/session/selectors';
import React, { FC, useMemo } from 'react';
import config from 'config/config';
import { useSelector } from 'react-redux';
import discordIcon from 'assets/images/social/discord-white.svg';
import { replaceString } from 'shared/utils';
import { useStyles } from './GlobalChat.styles';

const WIDGET_BOT_SHARD = 'https://emerald.widgetbot.io';

export const GlobalChat: FC = () => {
  const { classes } = useStyles();
  const currentUser = useSelector(sessionSelector.activeUser);

  const userImage = useMemo(() => {
    if (!currentUser.image) {
      return '';
    }

    return replaceString(currentUser.image, 'svg', 'jpg');
  }, [currentUser.image]);

  return (
    <Box className={classes.root}>
      <Box className={classes.linkContainer}>
        <Typography variant="subtitle2">
          <Link href={config.discordInviteUrl} target="_blank" sx={{ display: 'flex' }}>
            <Box className={classes.icon}>
              <img src={discordIcon} alt="discord" />
            </Box>
            Join the OkLetsPlay Discord!
          </Link>
        </Typography>
      </Box>
      {currentUser && (
        <WidgetBot
          server={config.discordServerId}
          channel={config.discordChannelId}
          username={currentUser.userName}
          avatar={userImage}
          className={classes.widget}
          height="100%"
          width="100%"
          shard={WIDGET_BOT_SHARD}
        />
      )}
    </Box>
  );
};
